import { errorNotifier } from "@src/main";

export const domain = document.body.dataset.siteDomain || "";

export async function request(url: string, option?: RequestInit) {
  const finalURL = `${domain}${url}`;
  try {
    return await fetch(finalURL, option);
  } catch (error) {
    errorNotifier.notify({
      error: error as Error,
      msg: `request ${finalURL} failed`,
    });
  }
}
